import { Link, usePage } from '@inertiajs/react'
import { ChartNoAxesCombined } from 'lucide-react'
import type { SharedProps } from '@/frontend/types/inertia'

// Dashboard viewers need a route even when Forge administration is hidden.
export default function CatalogLink({ onNavigate, compact = false }: { onNavigate: () => void; compact?: boolean }) {
  const { props, url } = usePage<SharedProps>()
  const path = url.split('?')[0]
  const active = path === '/dashboard/dashboards' || /^\/dashboard\/projects\/[^/]+\/dashboards(?:\/|$)/.test(path)
  const label = props.navigationLabels.dashboards
  return <Link href="/dashboard/dashboards" onClick={onNavigate} aria-current={active ? 'page' : undefined}
    aria-label={label} title={compact ? label : undefined}
    className={`flex items-center gap-2 rounded-lg px-3 py-2 text-[13.5px] font-medium ${compact ? 'justify-center' : ''} ${active
      ? 'bg-accent text-foreground' : 'text-muted-foreground hover:bg-accent hover:text-foreground'}`}>
    <ChartNoAxesCombined className="size-4 shrink-0" strokeWidth={1.75} />
    {!compact && <span>{label}</span>}
  </Link>
}
